import React from "react";
import ColorExplorationColorSummary from "./ColorExplorationColorSummary";

function ColorExplorationAnalyse() {
  return <ColorExplorationColorSummary pageMode="analyse" />;
}

export default ColorExplorationAnalyse;
